var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSync = function SvgSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.276 20.316v-1.5H8.2l-.727-.696Q6.24 16.98 5.72 15.567a8.2 8.2 0 0 1-.52-2.855q0-2.592 1.518-4.649 1.52-2.057 3.982-2.824v1.58a6.14 6.14 0 0 0-2.905 2.319A6.2 6.2 0 0 0 6.7 12.712q0 1.173.444 2.279.446 1.105 1.383 2.044l.635.635V14.93h1.5v5.385zm9.923-.27v-1.58a6.14 6.14 0 0 0 2.905-2.318 6.2 6.2 0 0 0 1.095-3.575q0-1.173-.444-2.278-.444-1.106-1.383-2.045l-.634-.634v2.738h-1.5V4.97h5.384v1.5H17.7l.727.696q1.187 1.186 1.73 2.576t.543 2.831q0 2.593-1.518 4.65-1.518 2.056-3.982 2.824"
  })));
};
export default SvgSync;